import React, { Children, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { EmptyStateContainer, FormLabel } from 'components';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
} from '@biq/apex-ui';
import {
    getQueryFromLocalStorage,
    SavedQueriesType,
    themeObject,
} from '../../../../../lib';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    HistoryComponentProps,
    historyComponentStyles,
    HistoryQueriesType,
} from './history-component-helper';
import { ChainSvg } from '../../../../../assets';

export const HistoryComponent = ({
    handleBackButtonClick,
    handleApplyButtonClick,
}: HistoryComponentProps): React.JSX.Element => {
    const [historyQueries, setHistoryQueries] = useState<HistoryQueriesType[]>(
        () =>
            getQueryFromLocalStorage('graphQueries').map(
                (item: SavedQueriesType) => ({
                    isExpanded: false,
                    query: item.query,
                    timestamp: item.timestamp,
                })
            )
    );

    const handleAccordionChange = (index: number): void => {
        setHistoryQueries((prevQueries) =>
            prevQueries.map((item, i) => ({
                ...item,
                isExpanded: i === index ? !item.isExpanded : false,
            }))
        );
    };

    return (
        <Grid sx={historyComponentStyles.mainContainerStyles}>
            <Grid sx={historyComponentStyles.labelAndButtonContainerStyles}>
                <FormLabel text='History' />
                <Grid>
                    <Button
                        size='medium'
                        variant='text'
                        startIcon={
                            <ArrowBackIcon
                                color={themeObject.palette.primary[400]}
                            />
                        }
                        onClick={handleBackButtonClick}
                    >
                        Back
                    </Button>
                </Grid>
            </Grid>
            <Grid sx={historyComponentStyles.accordionContainerStyles}>
                {historyQueries.length ? (
                    Children.toArray(
                        historyQueries.map(
                            (queryData: HistoryQueriesType, index: number) => {
                                return (
                                    <Accordion
                                        variant='outlined'
                                        expanded={queryData.isExpanded}
                                        sx={historyComponentStyles.widthStyles}
                                        onChange={(): void =>
                                            handleAccordionChange(index)
                                        }
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            header={queryData.timestamp}
                                            sx={
                                                historyComponentStyles.widthStyles
                                            }
                                        ></AccordionSummary>
                                        <AccordionDetails
                                            sx={
                                                historyComponentStyles.accordionDetailsStyles
                                            }
                                        >
                                            <Grid
                                                sx={
                                                    historyComponentStyles.accordionDetailsContainerStyles
                                                }
                                            >
                                                <Grid
                                                    sx={
                                                        historyComponentStyles.contentContainerStyles
                                                    }
                                                >
                                                    <Typography
                                                        sx={
                                                            historyComponentStyles.queryTextStyles
                                                        }
                                                    >
                                                        {queryData.query}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    sx={
                                                        historyComponentStyles.buttonContainerStyles
                                                    }
                                                >
                                                    <Button
                                                        sx={
                                                            historyComponentStyles.buttonStyles
                                                        }
                                                        onClick={(): void =>
                                                            handleApplyButtonClick(
                                                                queryData.query
                                                            )
                                                        }
                                                    >
                                                        Apply
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            }
                        )
                    )
                ) : (
                    <EmptyStateContainer
                        emptyStateIcon={ChainSvg}
                        customImageStyles={
                            historyComponentStyles.customImageStyles
                        }
                        customHeadingTextStyles={
                            historyComponentStyles.customHeadingTextStyles
                        }
                        customHeadingContainerStyles={
                            historyComponentStyles.customHeadingContainerStyles
                        }
                    />
                )}
            </Grid>
        </Grid>
    );
};
